<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <!-- Profile Sidebar -->
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><customer-sidebar></customer-sidebar></div>
                            <!-- /Profile Sidebar -->
                        </div>
                    </div>
                    <!-- / Profile Sidebar -->

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="d-sm-flex d-block justify-content-between align-items-end border-bottom mb-3">
                            <h2>Équipe - {{ team.name }}</h2>
                            <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                <li class="nav-item">
                                    <a class="nav-link text-xs h-100 px-2" :class="{ active: activeTab === 'general' }"
                                        @click="this.activeTab='general'" href="javascript:void(0)">Général</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link text-xs h-100 px-2" :class="{ active: activeTab === 'team_members' }"
                                        @click="this.activeTab='team_members'" href="javascript:void(0)">Joueurs</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link text-xs h-100 px-2" :class="{ active: activeTab === 'formation' }"
                                        @click="this.activeTab='formation'" href="javascript:void(0)">Formation</a>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-content pt-0">
                            <div v-if="activeTab === 'general'" class="tab-pane fade show active">
                                <form @submit.prevent="editTeam">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Nom de l'Équipe</label>
                                                <input type="text" class="form-control" v-model="team.name" required disabled=""/>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="d-flex flex-row align-items-center mt-1 mb-3">
                                                <img :src="previewUrl || defaultImage" class="mr-3" style="width: 70px;" />
                                                <label class="btn btn-primary text-xs rounded-pill mr-3 mb-0">
                                                    <b><i class="material-symbols-outlined text-sm mr-1">upload</i>
                                                        Importer votre logo</b>
                                                    <input type="file" class="d-none" @change="handleFileUpload"
                                                        accept="image/*">
                                                </label>
                                                <div class="text-muted">
                                                    <p class="text-xs m-0">Allowed JPG, JPEG or PNG.</p>
                                                    <p class="text-xs m-0">Max size of 2MB.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Délégation</label>
                                                <input type="text" class="form-control" :value="team.delegation" disabled=""/>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group card-label h-100 mb-3">
                                                <label>Stade Préféré</label>
                                                <v-select :options="establishments" v-model="team.preferred_establishment_id" label="label" :reduce="option => option.id"
                                                    class="custom-vs form-control input">
                                                    <template v-slot:option="option">
                                                        <span><b>{{ option.business_name }}</b> - {{ option.delegation }}</span>
                                                    </template>
                                                    <template v-slot:selected-option="option">
                                                        <span><b>{{ option.business_name }}</b> - {{ option.delegation }}</span>
                                                    </template>
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="submit-section">
                                        <button type="submit" class="btn btn-primary btn-rounded px-4">
                                            <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                            <label class="m-0 mx-1">Modifier</label>
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div v-if="activeTab === 'team_members'" class="tab-pane fade show active">
                                <div class="text-center">
                                    <a href="javascript:void(0)" data-toggle="modal" data-target="#searchPlayerModal" @click="openSearchPlayerModal()" 
                                        class="btn btn-sm bg-light text-xs d-inline-flex h-auto align-items-center rounded-pill px-3">
                                        <span class="material-symbols-outlined text-md mr-2">person_search</span>
                                        Rechercher un joueur
                                    </a>
                                </div>
                                <div v-if="teamMembers.length !== 0" class="table-responsive text-xs py-2 mb-4">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>Nom Joueur</th>
                                                <th>Age</th>
                                                <th>Poste</th>
                                                <th>Poste(s) Préférée(s)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in teamMembers" :key="item.id">
                                                <td>
                                                    <b class="mr-1">{{ item.player.name }}</b>
                                                    <span class="badge badge-pill bg-secondary-light px-2 text-xs" v-if="item.player.id === player.id">
                                                        Moi
                                                    </span>
                                                </td>
                                                <td>{{ item.player.age || '-' }}</td>
                                                <!-- <td>{{ membershipRoles[item.role] }}</td> -->
                                                <td>
                                                    <span v-if="item.lineup_position" class="badge p-2 ml-1" :class="playerPositions[item.lineup_position]?.class">
                                                        {{ playerPositions[item.lineup_position]?.abbr }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span v-for="position in (item.player.position || '').split(',').filter(Boolean)" class="badge p-2 ml-1" :class="playerPositions[position]?.class">
                                                        {{ playerPositions[position]?.abbr }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-if="activeTab === 'formation'" class="tab-pane fade show active">
                                <div>
                                    <div class="row justify-content-center">
                                        <div class="col-4 d-flex justify-content-end">
                                            <div class="form-group card-label h-100 mb-3" style="width: 120px;">
                                                <label>Format</label>
                                                <select class="form-control custom-select" v-model="team.format" required="">
                                                    <template v-for="n in 11">
                                                        <option v-if="n>=5" :value="n+'v'+n">{{ n }}v{{ n }}</option>
                                                    </template>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-4 d-flex justify-content-start">
                                            <div class="form-group card-label h-100 mb-3" style="width: 120px;">
                                                <label>Formation</label>
                                                <select class="form-control custom-select" v-model="selectedFormation">
                                                    <option v-for="formation in possibleFormations" :value="formation">{{ formation }}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3 mb-5 d-flex flex-sm-row flex-column justify-content-center align-items-center" v-if="lineup.length">
                                        <div class="mx-4 mb-3">
                                            <div class="mb-2">
                                                <span class="badge p-2 mr-2" :class="playerPositions['goalkeeper']['class']" style="min-width: 34px;">
                                                    {{ playerPositions['goalkeeper']['abbr'] }}
                                                </span>
                                                <select class="custom-select w-auto" :value="goalkeeper" @focus="capturePrevGoalkeeper()" @change="handleSelectGoalkeeper($event.target.value)">
                                                    <option disabled value="">Sélectionner Joueur</option>
                                                    <option v-for="p in players" :key="p.player.id" :value="p.player.id">
                                                        {{ p.player.name }}<template v-if="p.role=='captain'"> (C)</template>{{ isSelectedElsewhere(p.player.id, 'goalkeeper') ? ' (selected)' : '' }}
                                                    </option>
                                                    <!-- <option value="guest">Add Guest Player</option> -->
                                                </select>
                                            </div>
                                            <div v-for="(pos, idx) in lineup" :key="idx" class="mb-2">
                                                <span class="badge p-2 mr-2" :class="playerPositions[pos]['class']" style="min-width: 34px;">
                                                    {{ playerPositions[pos]['abbr'] }}
                                                </span>                                               
                                                <select class="custom-select w-auto" :value="lineupPlayers[idx]" @focus="capturePrev(idx)" @change="handleSelect(idx, $event.target.value)">
                                                    <option disabled value="">Sélectionner Joueur</option>
                                                    <option v-for="p in players" :key="p.player.id" :value="p.player.id">
                                                        {{ p.player.name }}<template v-if="p.role=='captain'"> (C)</template>{{ isSelectedElsewhere(p.player.id, idx) ? ' (selected)' : '' }}
                                                    </option>
                                                    <!-- <option value="guest">Add Guest Player</option> -->
                                                </select>
                                            </div>
                                            <div class="submit-section">
                                                <button type="submit" class="btn btn-primary w-100 submit-btn btn-rounded" @click.prevent="saveLineup()">
                                                    <span class="spinner-border spinner-border-sm text-white m-1 d-none" role="status" aria-hidden="true"></span>
                                                    <label class="m-0 mx-1">Enregistrer</label>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="bg-light rounded-lg bg-cover" style="width: 240px; height: 350px;" :style="'background-position: center;background-image: url('+require('@/assets/img/pitch-vertical.png')+');'">
                                            <div class="mt-3 d-flex justify-content-center" style="height: 40px;">
                                                <span class="bg-white rounded-sm shadow" style="height: fit-content;">
                                                    <span class="badge p-2" :class="playerPositions['goalkeeper']['class']" style="min-width: 34px;height: fit-content;">
                                                        {{ playerPositions['goalkeeper']['abbr'] }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="mt-3 mx-3 d-flex justify-content-around" style="height: 65px;">
                                                <span class="bg-white rounded-sm shadow" v-for="d in lineup.filter(p => p == 'defender')" style="height: fit-content;">
                                                    <span class="badge p-2" :class="playerPositions['defender']['class']" style="min-width: 34px;height: fit-content;">
                                                        {{ playerPositions['defender']['abbr'] }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="mt-3 d-flex justify-content-around" style="height: 60px;">
                                                <span class="bg-white rounded-sm shadow" v-for="m in lineup.filter(p => p == 'midfielder')" style="height: fit-content;">
                                                    <span class="badge p-2" :class="playerPositions['midfielder']['class']" style="min-width: 34px;height: fit-content;">
                                                        {{ playerPositions['midfielder']['abbr'] }}
                                                    </span>
                                                </span>
                                            </div>
                                            <div class="mt-3 mx-4 d-flex justify-content-around">
                                                <span class="bg-white rounded-sm shadow" v-for="f in lineup.filter(p => p == 'forward')" style="height: fit-content;">
                                                    <span class="badge p-2" :class="playerPositions['forward']['class']" style="min-width: 34px;height: fit-content;">
                                                        {{ playerPositions['forward']['abbr'] }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Page Content -->

        <!-- Footer -->
        <layout-footer />
        <!-- /Footer -->
    </div>

    <div class="modal fade" id="searchPlayerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 v-if="currentModalView === 'search'" class="modal-title">Rechercher un joueur</h5>
                    <h5 v-if="currentModalView === 'filters'" class="modal-title">Filtres de recherche</h5>
                    <button v-if="currentModalView === 'search'" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                    <button v-else @click="currentModalView = 'search'" type="button" class="btn btn-sm btn-outline-secondary">Retour</button>
                </div>
                <div class="modal-body">
                    <div class="modal-body p-0 mb-4" style="min-height: 30vh;">
                        <div id="searchData" v-if="currentModalView === 'search'">
                            <form class="form-inline">
                                <input type="text" v-model="search.criteria.players.name" class="form-control shadow-sm rounded-pill bg-light mr-2 w-auto" placeholder="Nom Joueur" style="min-height: 40px;">
                                <span class="btn bg-light rounded-pill d-flex align-items-center shadow-sm text-sm ml-1 py-2 px-3 position-relative" 
                                    @click="currentModalView = 'filters'" :class="{ 'border-dark text-dark': activeFiltersCount > 0, 'text-muted btn-light': activeFiltersCount === 0 }">
                                    <span class="material-symbols-outlined text-lg">tune</span>
                                    <span class="d-none d-md-inline ml-1 text-sm">Filtres</span>
                                    <span v-if="activeFiltersCount > 0"
                                        class="badge badge-dark text-white mr-2 mt-2 p-1 rounded-xl" 
                                        style="min-width: 20px; top:0; right:0; transform: translate(50%, -50%); position: absolute;">
                                        {{ activeFiltersCount }}
                                    </span>
                                </span>
                            </form>
                            <div v-if="filteredPlayersData.length > 0">
                                <div class="table-responsive text-xs pt-2">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>Nom Joueur</th>
                                                <th>Age</th>
                                                <th>Délégation</th>
                                                <th>Position(s)</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="player in paginatedPlayersData" :key="player.id">
                                                <td><b>{{ player.name }}</b></td>
                                                <td>{{ player.age || '-' }}</td>
                                                <td>{{ player.delegation || '-' }}</td>
                                                <td>
                                                    <span v-for="position in player.position?.split(',')" class="badge p-2 ml-1" :class="playerPositions[position]?.class">
                                                        {{ playerPositions[position]?.abbr }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="btn btn-sm btn-outline-info rounded-pill pt-0" @click="invite(player.id)">
                                                        <span class="text-xs">Inviter</span>
                                                    </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- PAGINATION -->
                                <nav class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: currentPlayersPage === 1 }">
                                            <button class="page-link text-dark" @click="goToPage(currentPlayersPage - 1, 'players')">
                                                <span class="material-symbols-outlined text-sm">arrow_back</span>
                                            </button>
                                        </li>
                                        <li class="page-item">
                                            <select class="page-link text-dark text-xs h-100" v-model="currentPlayersPage" @change="goToPage(Number(currentPlayersPage))">
                                                <option v-for="page in totalPlayerPages" :key="page" :value="page">
                                                    Page {{ page }}
                                                </option>
                                            </select>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentPlayersPage === totalPlayerPages }">
                                            <button class="page-link text-dark" @click="goToPage(currentPlayersPage + 1, 'players')">
                                                <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div v-else class="mt-5 text-sm text-center">
                                Aucune correspondance précise
                            </div>
                        </div>
                        <div id="playerFilters" v-if="currentModalView == 'filters'">
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">Délégation</label>
                                <v-select :options="delegations" v-model="criteria.delegation" label="option" :reduce="option => option" class="custom-vs form-control input w-auto">
                                    <template #option="{ option }">
                                        <span><b>{{ option.split(', ')[0]}}</b>, {{ option.split(', ')[1] }}</span>
                                    </template>
                                </v-select>
                            </div>
                            <div class="form-group card-label h-100 mb-3 w-auto" style="min-width: 120px;">
                                <label>Position(s)</label>
                                <div>
                                    <div class="custom-control custom-radio custom-control-inline mt-1 ml-2">
                                        <input type="checkbox" id="position1" v-model="criteria.position" value="goalkeeper" name="position[]" class="custom-control-input">
                                        <label class="custom-control-label" for="position1">Gardien</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="checkbox" id="position2" v-model="criteria.position" value="defender" name="position[]" class="custom-control-input">
                                        <label class="custom-control-label" for="position2">Défenseur</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="checkbox" id="position3" v-model="criteria.position" value="midfielder" name="position[]" class="custom-control-input">
                                        <label class="custom-control-label" for="position3">Milieu</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input type="checkbox" id="position4" v-model="criteria.position" value="forward" name="position[]" class="custom-control-input">
                                        <label class="custom-control-label" for="position4">Attaquant</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="currentModalView == 'filters'">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="resetFilters()">Réinitialiser</button>
                    <button type="button" class="btn btn-sm btn-primary" @click="applyFilters()">Appliquer</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="addGuestPlayerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Ajouter Joueur (Guest)</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <input v-model="guest.name" placeholder="Name" />
                    <select v-model="guest.position">
                        <option disabled value="">-- Select Position --</option>
                        <option>defender</option>
                        <option>midfielder</option>
                        <option>forward</option>
                    </select>
                </div>
                <div class="modal-footer">
                    <button @click="saveGuest">Save</button>
                    <button data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.nav-tabs.nav-justified > li > a {
    width: 100% !important;
}
</style>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import 'moment/locale/fr';
import { api } from "@/store";
import CustomerSidebar from "@/components/Customers/Partials/Sidebar";
import defaultImagePath from '@/assets/img/photo.png'

export default {
    components: {
        "customer-sidebar": CustomerSidebar,
        vSelect
    },
    props: ['id'],
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        },
        activeFiltersCount() {
            const keys = Object.keys(this.search.criteria.players)
            let activeFilters = 0
            keys.forEach(key => {
                const filter = this.criteria[key]
                if (!this.isEmpty(filter)) {
                    activeFilters++
                }
            })
            return activeFilters
        },
        filteredPlayersData() {
            let filteredData = this.search.players
            const keys = Object.keys(this.search.criteria.players)
            keys.forEach(key => {
                const filter = this.search.criteria.players[key]
                if (!this.isEmpty(filter)) {
                    filteredData = filteredData.filter(player => {
                        const value = player[key]
                        return (!Array.isArray(filter)) ? value?.toLowerCase().includes(filter.toLowerCase()) : 
                            filter.some(f => value?.toLowerCase().includes(f.toLowerCase()))
                    });
                }
            })
            return filteredData
        },
        totalPlayerPages() {
            return Math.ceil(this.filteredPlayersData.length / this.playersPerPage);
        },
        paginatedPlayersData() {
            const start = (this.currentPlayersPage - 1) * this.playersPerPage;
            return this.filteredPlayersData.slice(start, start + this.playersPerPage);
        },
    },
    data() {
        return {
            activeTab: 'general',
            defaultImage: defaultImagePath,
            previewUrl: null,
            selectedFile: null,
            team: {},
            teamMembers: [],
            selectedFormation: "",
            possibleFormations: [], // for 6v6
            membershipRoles: {
                'captain': 'Capitaine',
                'starting': 'Titulaire',
                'substitute': 'Remplaçant'
            },
            playerPositions: {
                'goalkeeper': {'abbr': 'G', 'class': 'bg-warning-light'},
                'defender': {'abbr': 'DF', 'class': 'bg-primary-light'},
                'midfielder': {'abbr': 'ML', 'class': 'bg-success-light'},
                'forward': {'abbr': 'AT', 'class': 'bg-danger-light'}
            },
            lineup: [],
            goalkeeper: '',
            lineupPlayers: [],
            guest: {},
            currentModalView: 'search',
            criteria: {
                position: [],
                delegation: null
            },
            search: {
                criteria: {
                    players: {
                        name: null,
                        position: [],
                        delegation: null
                    }
                },
                players: []
            },
            defaultCriteria: {
                delegation: null,
                position: null
            },
            user: {},
            player: {},
            currentPlayersPage: 1,     // selected page
            playersPerPage: 5,         // items per page
            players: [],
            prevSelectionSlots: [],
            prevSelectionGoalkeeper: "",
            establishments: []
        }
    },
    mounted() {
        this.user = this.currentUser
        this.getMyPlayerProfile()
        // this.team.delegation = this.user.delegation
        this.getDelegations()
        this.searchEstablishments()
        const vm = this
        $(document).ready(function() {
            
        })
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0]
            if (file) {
                this.selectedFile = file
                this.previewUrl = URL.createObjectURL(file)
            }
        },
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async getMyPlayerProfile() {
            api.get('/private/players/me')
                .then(response => {
                    const result = response.data
                    this.player = result
                    this.getTeam()
                })
        },
        async getTeam() {
            await api.get('/private/teams/'+this.id)
                .then(response => {
                    const result = response.data
                    this.team = result
                    this.selectedFormation = this.team.formation ? this.team.formation : ''
                    this.previewUrl = this.team.logo
                    this.players = this.teamMembers = this.team.memberships.filter(membership => membership.status == 'accepted')
                    this.possibleFormations = this.generateFormations(parseInt(this.team.format.split('v')[0]))
                    if (this.team.captain_id != this.player.id && this.team.owner_id != this.player.id) {
                        this.$router.push('/my/teams/'+this.id);
                    }
                })
        },
        invite(player_id) {
            console.log(player_id)
            this.$store.dispatch('modal/triggerModal', {
                stacked: true,
                title: 'Confirmation !',
                detail: 'Voulez-vous inviter ce joueur à votre équipe?',
                prompt: true,
                onResult: (confirmed) => {
                    if (confirmed) {
                        api.post(`/private/teams/${this.id}/invite/${player_id}`)
                            .then(response => {
                                    this.getTeam()
                                    this.search.players = this.search.players.filter(p => p.id !== player_id)
                                    setTimeout(() => {
                                        $('.modal-backdrop').remove()
                                        $('body').removeClass('modal-open')
                                        this.$store.dispatch('modal/triggerModal', {
                                            stacked: true,
                                            icon: 'check_circle',
                                            icon_color: 'text-success',
                                            title: 'Succès',
                                            detail: 'L\'invitation a été envoyée avec succès.',
                                        })
                                    }, 250)
                                })
                            .catch(error => {
                                    this.$store.dispatch('modal/triggerModal', {
                                        stacked: true,
                                        icon: 'error',
                                        icon_color: 'text-danger',
                                        title: 'Erreur',
                                        detail: error.response?.data?.message || 'Une erreur est survenue! Veuillez réessayer plus tard.',
                                    })
                                })
                    }
                }
            })
        },
        saveLineup() {
            const payload = {
                format: this.team.format,
                formation: this.selectedFormation,
                goalkeeper: this.goalkeeper,
                players: this.lineupPlayers.map((pid, idx) => ({
                    player_id: pid === "guest" ? null : pid,
                    lineup_position: this.lineup[idx],
                    guest_name: pid === "guest" ? "Guest Player" : null
                }))
            };
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            api.post(`/private/teams/${this.id}/lineup`, payload)
                .then(response => {
                    this.$store.dispatch('modal/triggerModal', {
                        icon: 'check_circle',
                        icon_color: 'text-success',
                        title: 'Succès',
                        detail: 'La formation a été mise à jour avec succès.'
                    })
                    console.log('Lineup saved successfully');
                    this.getTeam()
                }).finally(() => {
                    $('.submit-section button').removeAttr('disabled')
                    $('.submit-section button span').addClass('d-none')
                })
        },
        editTeam() {
            $('.submit-section button').attr('disabled', 'disabled')
            $('.submit-section button span').removeClass('d-none')
            const formData = new FormData()
            formData.append('form_data', JSON.stringify(this.team))
            formData.append('logo', this.selectedFile)
            setTimeout(() => {
                api.patch('/private/teams/' + this.id, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        console.log(response.status)
                        this.$store.dispatch('modal/triggerModal', {
                            icon: 'check_circle',
                            icon_color: 'text-success',
                            title: 'Succès',
                            detail: 'Votre équipe a été mise à jour avec succès.'
                        })
                    })
                    .catch(error => {
                        this.$store.dispatch('modal/triggerModal', {
                            icon: 'error',
                            icon_color: 'text-danger',
                            title: 'Erreur',
                            detail: 'Une erreur s\'est produite lors de la mise à jour de l\'équipe.'
                        })
                    })
                    .finally(() => {
                        $('.submit-section button').removeAttr('disabled')
                        $('.submit-section button span').addClass('d-none')
                        this.getTeam()
                    })
            }, 2000);
        },
        searchPlayers() {
            const excludeIds = this.team.memberships.filter(member => ['accepted', 'pending'].includes(member.status))
                .map(member => member.player.id)
            console.log(excludeIds)
            api.get('/private/players/search')
                .then(response => {
                    const result = response.data
                    this.search.players = result.filter(player => !excludeIds.includes(player.id))
                    this.currentPlayersPage = 1
                })
        },
        searchEstablishments() {
            api.post('/search/establishments', {})
                .then(response => {
                    const result = response.data
                    result.forEach(e => {
                        let establishment = e
                        establishment.label = e.business_name + ' - ' + e.delegation
                        this.establishments.push(establishment)
                    })
                })
        },
        openSearchPlayerModal() {
            this.searchPlayers()
        },
        applyFilters() {
            this.search.criteria.players = {
                ...this.search.criteria.players,
                ...this.criteria
            }
            console.log(this.criteria)
            this.currentModalView = 'search'
        },
        resetFilters() {
            this.criteria = {
                position: [],
                delegation: null
            }
            this.applyFilters()
        },
        generateFormations(totalPlayers) {
            const outfield = totalPlayers - 1; // exclude goalkeeper
            const formations = [];

            for (let d = 1; d <= outfield - 2; d++) {
                for (let m = 1; m <= outfield - d - 1; m++) {
                    const f = outfield - d - m;
                    if (f >= 1) {
                        formations.push(`${d}-${m}-${f}`);
                    }
                }
            }
            return formations;
        },
        // NEW: capture previous selection before change
        capturePrev(idx) {
            this.prevSelectionSlots[idx] = this.lineupPlayers[idx];
        },
        capturePrevGoalkeeper() {
            this.prevSelectionGoalkeeper = this.goalkeeper;
        },

        // NEW: utility to detect if ID is selected elsewhere (for UI hint)
        isSelectedElsewhere(id, currentSlot) {
            if (!id || id === "guest") return false;
            const inGK = currentSlot !== "goalkeeper" && this.goalkeeper === id;
            const inLineup =
                typeof currentSlot === "number" &&
                this.lineupPlayers.some((pid, i) => i !== currentSlot && pid === id);
            const inSlotWhenGK =
                currentSlot === "goalkeeper" &&
                this.lineupPlayers.some(pid => pid === id);
            return inGK || inLineup || inSlotWhenGK;
        },
        // NEW: handle select for outfield slots with swap behavior
        handleSelect(idx, newId) {
            // If guest, just assign
            if (newId === "guest") {
                this.lineupPlayers[idx] = newId;
                return;
            }

            const oldId = this.prevSelectionSlots[idx];

            // Find if newId is already selected in another slot (exclude current idx)
            const otherIndex = this.lineupPlayers.findIndex(
                (pid, i) => i !== idx && pid === newId
            );

            if (otherIndex !== -1) {
                // Swap values: put oldId into the other slot, set newId here
                this.lineupPlayers[idx] = newId;
                this.lineupPlayers[otherIndex] = oldId || "";
            } else if (this.goalkeeper === newId) {
                // If newId is currently GK, swap with GK
                this.lineupPlayers[idx] = newId;
                this.goalkeeper = oldId || "";
            } else {
                // Simple assignment if not used elsewhere
                this.lineupPlayers[idx] = newId;
            }
        },
        // NEW: handle select for goalkeeper with swap behavior
        handleSelectGoalkeeper(newId) {
            if (newId === "guest") {
                this.goalkeeper = newId;
                return;
            }
            const oldGK = this.prevSelectionGoalkeeper;

            const outfieldIndex = this.lineupPlayers.findIndex(pid => pid === newId);
            if (outfieldIndex !== -1) {
                // Swap GK with that outfield slot
                this.goalkeeper = newId;
                this.lineupPlayers[outfieldIndex] = oldGK || "";
            } else {
                this.goalkeeper = newId;
            }
        },
        generateLineup() {
            // Convert formation string into positions
            // Example: "2-2-1" => ["defender","defender","midfielder","midfielder","forward"]
            const parts = this.selectedFormation.split("-").map(Number);
            const positions = [];
            if (parts.length === 3) {
                positions.push(...Array(parts[0]).fill("defender"));
                positions.push(...Array(parts[1]).fill("midfielder"));
                positions.push(...Array(parts[2]).fill("forward"));
            }
            this.lineup = positions;
            this.lineupPlayers = Array(positions.length).fill("");
            this.prevSelectionSlots = Array(positions.length).fill("");
        },
        goToPage(page, list='players') {
            if (list == 'players' && page >= 1 && page <= this.totalPlayerPages) {
                this.currentPlayersPage = page;
            }
        },
        isEmpty(obj) {
            return obj === '' || obj == [] || obj === null || obj === undefined || 
                (typeof obj === 'object' && Object.keys(obj).length === 0);
        },
        itemText() {
            return Object.keys(item)
                .filter(key => ['business_name', 'delegation'].includes(key)) // exclude id
                .reduce((acc, key) => acc + " " + item[key], "")
                .trim();
        }
    },
    watch: {
        'selectedFormation': function(newValue, oldValue) {
            this.generateLineup()
            if (this.team.formation && !oldValue) { 
                const starting = this.teamMembers.filter(membership => ['captain', 'starting'].includes(membership.role))
                starting.forEach(m => {
                    if (m.lineup_position === "goalkeeper") {
                        this.goalkeeper = m.player_id;
                    } else {
                        // Find index of next slot with that position
                        const idx = this.lineup.findIndex(
                            (pos, i) => pos === m.lineup_position && !this.lineupPlayers[i]
                        );
                        if (idx !== -1) {
                            this.lineupPlayers[idx] = m.player_id;
                        }
                    }
                });
            }
        },
        'team.format': function(newValue, oldValue) {
            this.possibleFormations = this.generateFormations(parseInt(newValue.split('v')[0]))
        }
    }
};
</script>
